"use client";

import Script from "next/script";

type GoogleTagManagerProps = {
  readonly gtmId: string;
};

/**
 * The GTM container snippet. Consent Mode is relayed by the instrumentation
 * stack's gtm sink (the page's ONE relay), and the root layout sets the
 * all-denied defaults before this loads — nothing here reads consent.
 */
export function GoogleTagManager({ gtmId }: GoogleTagManagerProps) {
  return (
    <Script
      dangerouslySetInnerHTML={{
        // crossorigin=anonymous on the injected tag lets window.onerror expose
        // real error messages from gtm.js instead of opaque "Script error."
        // (googletagmanager.com serves Access-Control-Allow-Origin: *).
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.crossOrigin='anonymous';j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`,
      }}
      id="gtm-script"
      strategy="afterInteractive"
    />
  );
}
